import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { PortfolioSection } from './components/PortfolioSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { MouseFollower } from './components/MouseFollower';
import './index.css';
export function App() {
  return <main className="bg-dark min-h-screen w-full" data-id="element-0">
      <MouseFollower data-id="element-1" />
      <Navbar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <AboutSection data-id="element-4" />
      <ServicesSection data-id="element-5" />
      <PortfolioSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <ContactSection data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}